<script lang="ts">
  import { createEventDispatcher } from "svelte";

  const dispatcher = createEventDispatcher();

  function rememberdPassword() {
    dispatcher("modeChanged", "login");
  }
</script>

<h2 class="mb-4 text-18 font-bold text-nxgray-600">Reset your Smore password</h2>
<p class="w-full text-13 text-nxgray-400">Check your email for instructions on how to reset your password!</p>
<button
  class="clickable mt-5 flex w-full justify-center rounded bg-warning-600 py-3 text-15 font-bold text-white outline-none hover:bg-warning-500 focus:bg-warning-500 focus:outline-none"
  on:click={rememberdPassword}>Back to login</button>
